import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';
import {
  useMediaQuery,
  Grid2 as Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  List,
  colors
} from '@mui/material';
import { IconAlternate, SectionHeader } from 'components/molecules';

const useStyles = makeStyles(theme => ({
  listItem: {
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  listItemAvatar: {
    marginRight: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginBottom: theme.spacing(2),
    },
  },
  listItemText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    margin: 0,
    height: '100%',
  },
  title: {
    fontWeight: 'bold',
  },
}));

const WhyItMatters = props => {
  const { data, className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <SectionHeader
        title="What is ONDC and Why it Matters?"
        subtitle=""
      />
      <Grid container spacing={isMd ? 2 : 1}>
        {data.map((item, index) => (
          <Grid key={index} size={{ xs: 12, md: 4 }}>            
            <Card
              sx={{
                // backgroundColor: '#283593',
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                height: '100%',
                borderLeft: '4px solid',
                borderRadius: 2,                
                borderLeftColor: 'secondary.main',
              }}
              elevation={2}
            >
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  {item.title}
                </Typography>
                <Typography sx={{ opacity: 0.9 }}>
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>      
        ))}
      </Grid>
    </div>
  );
};

WhyItMatters.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default WhyItMatters;
